<template>
  <div class="setAmountDetail">
    <div class="topArea">
      <div class="banner">
        <div class="stitle">本次收款</div>
        <div class="number">{{total}}</div>
        <van-row class="bottomRow">
          <van-col class="b-col" span="12">
            <span>应收：</span>
            <span>{{dueTotal}}</span>
          </van-col>
          <div class="gutter-line"></div>
          <van-col class="b-col" span="12">
            <span>折扣：</span>
            <span>{{(+discount).toFixed(2)}}</span>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-row class="type">
      <van-row class="border">
        <van-field class="pr-input" input-align='right' disabled type='number' label="服务费应收" :value="$store.state.lackFeeAmount"/>
      </van-row>
    </van-row>
    <van-row>
      <van-row class="border">
        <van-field class="pr-input" input-align='right' type='number' label="服务费实收" v-model="serviceFee"/>
      </van-row>
    </van-row>
    <van-row>
      <van-row>
        <van-field class="pr-input" :disabled='!isDiscountCanEdit && $store.state.allReceivale === "1"' input-align='right' type='number' label="服务费折扣" v-model="discount"/>
      </van-row>
    </van-row>
    <van-row
      v-for="(fee,index) in feeTypeList"
      :key="fee.feeItemId"
      :class="index == 0 ? 'type' : ''"
    >
      <van-row class="border">
        <van-field class="pr-input" input-align='right' type='number' :label="fee.feeItemName" v-model="AmountList[index]"/>
      </van-row>
    </van-row>
    
    <van-row class="btnRow" @click.native="confirmClick({lackFeeAmount:total,currentType:'acct'})">确定</van-row>
  </div>
</template>

<script>
import Vue from "vue";
import * as math from 'mathjs';
import { Row, Col, Icon, Toast, Field } from "vant";
Vue.use(Row)
  .use(Col)
  .use(Icon)
  .use(Field);

export default {
  name: "setAmountDetail",
  components: {},
  data() {
    return {
      feeTypeList: [],
      serviceFee:this.$store.state.collectionTypeInfo.serviceFee || this.$store.state.lackFeeAmount,
      discount:this.$store.state.collectionTypeInfo.discount || 0,
      AmountList:this.$store.state.collectionTypeInfo.AmountList || [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      isDiscountCanEdit:false,
      tempMonthService:null
    };
  },
  computed:{
      dueTotal: function(){
              let sum = 0;
              for( let i = 0; i < this.AmountList.length; i++ ) {
                  sum = this.printFn(sum + Number(this.AmountList[i]));
              }
              sum = this.printFn(sum + Number(this.$store.state.lackFeeAmount));
              return sum.toFixed(2);
          },
      total: function(){
              let sum = 0;
              for( let i = 0; i < this.AmountList.length; i++ ) {
                  sum = this.printFn(sum + Number(this.AmountList[i]));
              }
              sum = this.printFn(sum + Number(this.serviceFee));
              return sum.toFixed(2);
          }
  },
  watch:{
    serviceFee(newVal,oldVal){
      console.log(newVal,oldVal)
      if(Number(this.$store.state.lackFeeAmount) > Number(newVal)){
        this.isDiscountCanEdit = true;
        this.discount = this.cal.accSub(Number(this.$store.state.lackFeeAmount),Number(newVal));
      }else{
         this.isDiscountCanEdit = false;
         this.discount = 0;
      }
    }
  },
  methods: {
    //js精度计算
    printFn(value) {
        const precision = 14
        return Number(math.format(value, precision))
    },
    init() {
      this.getRenewDetail();
    },
    linkSkip(name, params, redType, rid) {
      if (rid) {
        this.$root.$emit("log-record", rid);
      }
      this.$router.push({
        name: name,
        query: params
      });
    },
    getRenewDetail() {
      let url = "/fc/small/program/fee/item";
      this.$http
        .get(url)
        .then(res => {
          if (res.data.code == 200) {
            console.log(res, "/fc/small/program/fee/item");
            let rdata = res.data.data
            this.tempMonthService = res.data.data[0];
            rdata.splice(0,1);
            this.feeTypeList = rdata
            // res.data.data.forEach((p,index)=>{
            //   if(p.feeItemName == "服务费"){
            //     this.$set(this.AmountList,index,this.$store.state.collectionTypeInfo.AmountList[0] || this.$store.state.lackFeeAmount)
            //   }
            // })
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          Toast(error);
        });
    },
    confirmClick(params){
      if(this.total<0){
        Toast('本次应收金额不能为负数,请重新填写');
        return
      }
      if(this.printFn(Number(this.serviceFee) + Number(this.discount)) > Number(this.$store.state.lackFeeAmount) && this.discount !=0 && this.$store.state.allReceivale === '1'){
        Toast('服务费实收 + 服务费折扣不能大于服务费应收');
        return
      }

      this.$store.dispatch("setCollectionTypeInfo", {AmountList:this.AmountList,discount:this.discount,serviceFee:this.serviceFee});

      //下单需要传的 feeExtra 字段
      let feeExtra = this.feeTypeList.map((p,index) =>{
        return {aliasName:p.aliasName || "",feeItemName:p.feeItemName,feeItemId:p.feeItemId,feeItemAmount:(+this.AmountList[index]).toFixed(2)}
      });

      //{feeItemId: 451, feeItemName: "服务费", aliasName: "monthService", isSystem: true, serviceType: 1}

      //拼上服务费
      feeExtra.unshift({aliasName:"monthService",feeItemName:"服务费",feeItemId:this.tempMonthService.feeItemId,feeItemAmount:(+this.serviceFee).toFixed(2)})


      //拼上折扣
      feeExtra.push({aliasName:"",feeItemName:"折扣",feeItemId:0,feeItemAmount:(+this.discount).toFixed(2)})

      sessionStorage.setItem("_feeExtra",JSON.stringify(feeExtra));

      this.$router.push({
        name: 'setCollectionAmount',
        query: params
      });
    }
  },
  mounted: function() {
    // this.$root.$emit('log-record',"60010100");
    //滚动条置顶
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.init();
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.setAmountDetail {
  padding-bottom: 0.64rem;
  position: relative;
  .van-field{
    padding: 0.12rem 0.16rem;
  }
  .topArea {
    background-color: #ffffff;
  }

  .banner {
    width: 3.65rem;
    height: 1.38rem;
    margin: 0 auto;
    background: url('../../../assets/wxRenew/banner-bg.png') no-repeat center;
    background-size: cover;
    text-align: center;
    color: #ffffff;
    overflow: hidden;

    .number {
      font-size: 0.27rem;
      margin-top: 0.08rem;
      font-weight: bold;
    }
  }

  .cell {
    background-color: #ffffff;
    font-size: 0.16rem;
    padding-left: 0.16rem;
  }

  .cell-body {
    padding: 0.08rem 0.12rem;
    padding-left: 0;
  }

  .title {
    color: #1A2633;
    font-size: 0.17rem;
  }

  .rightText {
    text-align: right;
    color: #516374;
    font-size: 0.14rem;
    line-height: 0.23rem;
  }

  .leftText {
    color: #516374;
    font-size: 0.14rem;
  }

  .type {
    margin-top: 0.08rem;
  }

  .margnTop {
    margin-top: 0.1rem;
  }

  .task {
    color: #516374;
  }

  .pcolor {
    color: #1fadf6;
  }

  .border {
    border-bottom: 1px solid #f0f2f2;
  }

  .gutter-line {
    position: absolute;
    left: 50%;
    top: 0.04rem;
    width: 0.01rem;
    height: 0.14rem;
    background-color: #ffffff;
  }

  .stitle {
    margin-top: 0.24rem;
  }

  .bottomRow {
    position: relative;
    margin-top: 0.12rem;
  }
  .btnRow {
    padding: 0.16rem 0.12rem;
    text-align: center;
    color: #1FADF6;
    background-color: #ffffff;
    border-top: 1px solid #f0f2f2;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    font-size: 0.17rem;
    box-sizing: border-box;
    font-weight 500
  }
}
</style>
<style>
 .pr-input input{
    padding-right: 0.24rem;
  }
</style>

